import React, { Component, Fragment } from 'react';
import './TaskView.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { history } from 'components/App/components/UnauthenticatedApp';
import Linkify from 'react-linkify';

/**
 * Import components
 */
import Subject from 'components/UI/Subject/Subject';
import Button from 'components/UI/Button/Button';
import DropDown from 'components/UI/DropDown/DropDown';

/**
 * Import Actions
 */

import updateTask from 'actions/task/update';
import deleteTask from 'actions/task/destroy';
import taskStore from 'actions/task/store';

const mapStateToProps = (state, props) => {
    return {
        tasks: state.task.entities,
        subjects: state.user_subject.entities,
        homework: state.homework.entities,
        colors: state.color.entities,
        user: state.authentication.user
    };
};

const mapDispatchToProps = {
    updateTask,
    deleteTask,
    taskStore
};

const timeOptionArray = [
    5,
    10,
    15,
    20,
    25,
    30,
    40,
    50,
    60,
    75,
    90,
    120,
    150,
    180
];

class TaskView extends Component {
    constructor() {
        super();
        this.state = {
            months: [
                'januari',
                'februari',
                'maart',
                'april',
                'mei',
                'juni',
                'juli',
                'augustus',
                'september',
                'oktober',
                'november',
                'december'
            ],
            tasks: [],
            showUpdate: false,
            showSplit: false,
            taskName: '',
            updatedTaskTime: null,
            steps: [
                {
                    name: '',
                    time: 10
                },
                {
                    name: '',
                    time: 10
                }
            ]
        };

        this.switchTaskCompletion = this.switchTaskCompletion.bind(this);
        this.deleteTask = this.deleteTask.bind(this);
        this.goToTimer = this.goToTimer.bind(this);
        this.updateTask = this.updateTask.bind(this);
        this.splitTask = this.splitTask.bind(this);
        this.showUpdate = this.showUpdate.bind(this);
        this.showSplit = this.showSplit.bind(this);
        this.handleText = this.handleText.bind(this);
        this.handleTimeChange = this.handleTimeChange.bind(this);
        this.handleStepAmountChange = this.handleStepAmountChange.bind(this);
        this.handleStepNameChange = this.handleStepNameChange.bind(this);
        this.handleStepTimeChange = this.handleStepTimeChange.bind(this);
    }

    componentDidMount() {
        this.setState({
            taskName: this.props.task.name,
            updatedTaskTime: this.props.task.time
        });
    }

    wrapperClick(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    switchTaskCompletion() {

        const onlyAllowMarkingAsFinished = this.props.onlyAllowMarkingAsFinished;

        this.props
            .updateTask({
                ...this.props.task,
                status:
                    this.props.task.status == 'finished'
                        ? 'not_started'
                        : 'finished'
            })
            .then(result => {
                if (onlyAllowMarkingAsFinished) {
                    this.props.onClose();
                }
                // this.props.onClose();
            })
            .catch(error =>
                alert('Er ging iets mis met het bijwerken van de taak')
            );
    }

    goToTimer() {
        history.push(`/timer/${this.props.task.date}/${this.props.task.id}`);
    }

    deleteTask() {
        if (confirm('Weet je zeker dat je deze taak wil verwijderen?')) {
            this.props
                .deleteTask(this.props.task.id)
                .then(result => {
                    this.props.onClose();
                })
                .catch(error => console.log(error));
        }
    }

    updateTask() {
        let updatedTask = {
            ...this.props.task,
            id: this.props.task.id,
            name: this.state.taskName,
            time: parseInt(this.state.updatedTaskTime)
        };

        this.props.updateTask(updatedTask);

        this.setState({
            showUpdate: false
        });
    }

    splitTask() {
        this.props.deleteTask(this.props.task.id);

        for (let i = 0; i < this.state.steps.length; i++) {
            let newTask = {
                ...this.state.steps[i],
                status: 'not_started',
                order: i + 1,
                time: parseInt(this.state.steps[i].time)
            };

            if (this.props.task.homework_id) {
                newTask.homework_id = this.props.task.homework_id;
            }

            this.props.taskStore(newTask);
        }

        this.setState({
            showSplit: false,
            steps: [
                {
                    name: '',
                    time: 10
                },
                {
                    name: '',
                    time: 10
                }
            ]
        });

        this.props.onClose();
    }

    showUpdate() {
        this.props.task.status !== 'finished'
            ? this.setState({
                showUpdate: true
            })
            : null;
    }

    showSplit() {
        this.props.task.status !== 'finished'
            ? this.setState({
                showSplit: true
            })
            : null;
    }

    handleText(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleTimeChange(e) {
        this.setState({
            updatedTaskTime: e.target.value
        });
    }

    handleStepAmountChange(event) {
        let newCount = parseInt(event.target.value);
        let newSteps = this.state.steps;
        let difference = 0;

        if (newSteps[newSteps.length - 1].name == 'HH') {
            newSteps[newSteps.length - 1].name = '';
        }

        if (newCount < this.state.steps.length) {
            if (!confirm('Let op, je huidige taken gaan verloren')) {
                return;
            }

            difference = this.state.steps.length - newCount;

            newSteps.splice(difference * -1, difference);
        } else {
            difference = newCount - this.state.steps.length;

            newSteps = this.state.steps;

            for (let index = 0; index < difference; index++) {
                newSteps.push({ name: '', time: 10 });
            }
        }

        if (
            this.props.homework &&
            (this.props.homework.type == 'learn' ||
                this.props.homework.type == 'make_learn')
        ) {
            newSteps[newSteps.length - 1].name = 'HH';
        }

        this.setState({ steps: newSteps });
    }

    handleStepNameChange(value, index) {
        let newSteps = this.state.steps;
        let newStep = newSteps[index];
        newStep.name = value;

        newSteps[index] = newStep;

        this.setState({ steps: newSteps });
    }

    handleStepTimeChange(value, index) {
        let newSteps = this.state.steps;
        let newStep = newSteps[index];
        newStep.time = value;

        newSteps[index] = newStep;

        this.setState({ steps: newSteps });
    }

    render() {
        const { task, period, user, onlyAllowMarkingAsFinished } = this.props;

        let isFreeTask = task.homework_id == null;
        let homework = null;
        let subject = null;
        homework = this.props.homework.byId[task.homework_id];
        subject =
            homework && this.props.subjects.byId[homework.user_subject_id];

        const isMarked = homework && homework.mark;

        let stepCount =
            homework &&
            this.props.tasks.allIds
                .map(taskId => this.props.tasks.byId[taskId])
                .filter(task => task.homework_id == homework.id).length;

        let options = [];

        for (let index = 0; index < timeOptionArray.length; index++) {
            options.push(
                <option key={index} value={timeOptionArray[index]}>
                    {timeOptionArray[index]} min
                </option>
            );
        }

        let stepCreators = [];

        for (let index = 0; index < this.state.steps.length; index++) {
            stepCreators.push(
                <StepCreator
                    index={index}
                    step={this.state.steps[index]}
                    handleTextChange={this.handleStepNameChange}
                    handleTimeChange={this.handleStepTimeChange}
                    user={user}
                />
            );
        }

        return (
            <div styleName="input-content">
                <h1 styleName="title">
                    Taak{' '}
                    {this.state.showUpdate
                        ? 'wijzigen'
                        : this.state.showSplit
                            ? 'opsplitsen'
                            : ''}
                </h1>
                <div onClick={this.wrapperClick} styleName="card-content">
                    <div styleName="task-wrapper">
                        <div styleName="subject-wrapper">
                            {isFreeTask ? (
                                task.name == 'plenda_pauze' ? (
                                    <Subject pause color="#f8e764" />
                                ) : (
                                    <Subject misc color="#f8e764" />
                                )
                            ) : (
                                <Subject
                                    abbreviation={
                                        subject && subject.subject_abbreviation
                                    }
                                    color={
                                        subject &&
                                        (homework || isSchedule) &&
                                        subject.color_id &&
                                        this.props.colors.allIds.length > 0 &&
                                        this.props.colors.byId[subject.color_id]
                                            .color
                                    }
                                />
                            )}
                        </div>
                        {homework && (
                            <div styleName="type">
                                {homework && homework.type == 'make' && 'M'}
                                {homework && homework.type == 'learn' && 'L'}
                                {homework &&
                                    homework.type == 'make_learn' &&
                                    'ML'}
                                {homework && homework.type == 'read' && 'LZ'}
                            </div>
                        )}
                        <div
                            styleName={`description ${
                                isMarked ? 'marked' : ''
                            }`}
                        >
                            <p>
                                {task.name == 'plenda_pauze'
                                    ? 'Pauze'
                                    : task.name}{' '}
                                {((homework && homework.note) ||
                                    (isFreeTask && task.note)) && (
                                    <FontAwesomeIcon
                                        icon={[ 'fal', 'paperclip' ]}
                                    />
                                )}
                            </p>
                        </div>

                        {this.props.user.use_timer ? (
                            <div styleName="time">{task.time} min</div>
                        ) : null}

                        {!this.state.showUpdate && !this.state.showSplit && (
                            <Fragment>
                                <FontAwesomeIcon
                                    onClick={this.switchTaskCompletion}
                                    style={{
                                        marginLeft: '10px',
                                        cursor: 'pointer',
                                        color:
                                            task.status == 'finished'
                                                ? '#f8e764'
                                                : '#FFF'
                                    }}
                                    icon={[ 'fas', 'check' ]}
                                />

                                {!onlyAllowMarkingAsFinished && <FontAwesomeIcon
                                    onClick={this.goToTimer}
                                    style={{
                                        marginLeft: '10px',
                                        cursor: 'pointer'
                                    }}
                                    icon={[ 'fas', 'play' ]}
                                />}

                                
                            </Fragment>
                        )}
                    </div>
                    {!homework && task.image && (
                        <div styleName="image-wrapper">
                            <Button
                                title="bijlage bekijken"
                                normal
                                style={{
                                    background: 'rgba(255, 255, 255, 0.1)',
                                    color: '#fff',
                                    borderRadius: '3px',
                                    height: '36px',
                                    width: '224px',
                                    marginBottom: '15px'
                                }}
                                icon={[ 'fal', 'paperclip' ]}
                                smallIcon
                                handleClick={() => window.open(task.image)}
                            />
                        </div>
                    )}
                    {!this.state.showSplit && !this.state.showUpdate && !onlyAllowMarkingAsFinished && (
                        <div styleName="control-wrapper">
                            <div
                                style={
                                    this.props.task.status === 'finished'
                                        ? { opacity: '0.5' }
                                        : {}
                                }
                                styleName={
                                    task.name == 'plenda_pauze'
                                        ? 'control-button pause'
                                        : 'control-button'
                                }
                                onClick={this.showUpdate}
                            >
                                <p
                                    style={
                                        this.props.task.status === 'finished'
                                            ? { opacity: '0.5' }
                                            : {}
                                    }
                                    styleName="control-text"
                                >
                                    Wijzigen
                                </p>
                            </div>
                            {task.name !== 'plenda_pauze' && (
                                <div
                                    style={
                                        this.props.task.status === 'finished'
                                            ? { opacity: '0.5' }
                                            : {}
                                    }
                                    styleName="control-button"
                                    onClick={this.showSplit}
                                >
                                    <p
                                        style={
                                            this.props.task.status ===
                                            'finished'
                                                ? { opacity: '0.5' }
                                                : {}
                                        }
                                        styleName="control-text"
                                    >
                                        Opsplitsen
                                    </p>
                                </div>
                            )}
                            <div
                                style={
                                    task.name == 'plenda_pauze'
                                        ? { width: '100%', marginLeft: '3px' }
                                        : {}
                                }
                                styleName="control-button red"
                                onClick={this.deleteTask}
                            >
                                <p styleName="control-text">Verwijderen</p>
                            </div>
                        </div>
                    )}

                    {task.note && (
                        <div styleName="note">
                            <p>{task.note}</p>
                        </div>
                    )}

                    {!this.state.showUpdate &&
                        !this.state.showSplit &&
                        homework && (
                        <Fragment>
                            <h2>Onderdeel van: </h2>

                            <div styleName="homework-wrapper">
                                <div styleName="homework">
                                    <Subject
                                        abbreviation={
                                            subject &&
                                                subject.subject_abbreviation
                                        }
                                        color={
                                            subject &&
                                                (homework || isSchedule) &&
                                                subject.color_id &&
                                                this.props.colors.allIds
                                                    .length > 0 &&
                                                this.props.colors.byId[
                                                    subject.color_id
                                                ].color
                                        }
                                    />
                                    {homework && (
                                        <div styleName="type">
                                            {homework.type == 'make' && 'M'}
                                            {homework.type == 'learn' &&
                                                    'L'}
                                            {homework.type ==
                                                    'make_learn' && 'ML'}
                                            {homework.type == 'read' &&
                                                    'LZ'}
                                        </div>
                                    )}
                                    <div
                                        styleName={`description ${
                                            isMarked ? 'marked' : ''
                                        }`}
                                    >
                                        <p>
                                            {homework.description}{' '}
                                            {((homework && homework.note) ||
                                                    (isFreeTask &&
                                                        task.note)) && (
                                                <FontAwesomeIcon
                                                    icon={[
                                                        'fal',
                                                        'paperclip'
                                                    ]}
                                                />
                                            )}
                                        </p>
                                    </div>
                                </div>

                                <div styleName="note">
                                    <p><Linkify>{homework.note}</Linkify></p>
                                    {homework.image && (
                                        <Button
                                            title="bijlage bekijken"
                                            normal
                                            style={{
                                                background:
                                                        'rgba(255, 255, 255, 0.1)',
                                                color: '#fff',
                                                borderRadius: '3px',
                                                height: '36px',
                                                width: '210px',
                                                marginBottom: '15px',
                                                fontWeight: '300'
                                            }}
                                            icon={[ 'fal', 'paperclip' ]}
                                            smallIcon
                                            handleClick={() =>
                                                window.open(homework.image)
                                            }
                                        />
                                    )}
                                </div>

                                <strong>
                                        Verdeeld in {stepCount} stap
                                    {stepCount > 1 ? 'pen' : ''}
                                </strong>
                            </div>
                        </Fragment>
                    )}

                    {this.state.showUpdate && (
                        <Fragment>
                            <p style={{ color: 'white' }}>Wijzigen naar:</p>
                            <div styleName="update-wrapper">
                                {task.name !== 'plenda_pauze' && (
                                    <input
                                        styleName="update-input"
                                        name="taskName"
                                        value={this.state.taskName}
                                        onChange={this.handleText}
                                        maxLength="30"
                                    />
                                )}
                                <DropDown
                                    borderRadius="5px"
                                    type="dark"
                                    border
                                    width={
                                        task.name == 'plenda_pauze'
                                            ? '100%'
                                            : '130px'
                                    }
                                >
                                    <select
                                        value={this.state.updatedTaskTime}
                                        onChange={this.handleTimeChange}
                                    >
                                        {options}
                                    </select>
                                </DropDown>
                            </div>

                            <div styleName="buttons">
                                <p
                                    onClick={() =>
                                        this.setState({ showUpdate: false })
                                    }
                                >
                                    Annuleer
                                </p>
                                <p styleName="save" onClick={this.updateTask}>
                                    Opslaan
                                </p>
                            </div>
                        </Fragment>
                    )}

                    {this.state.showSplit && (
                        <Fragment>
                            <p style={{ color: 'white' }}>Opsplitsen in:</p>
                            <DropDown type="dark" border>
                                <select
                                    value={this.state.steps.length}
                                    onChange={this.handleStepAmountChange}
                                >
                                    <option value="2">2 taken</option>
                                    <option value="3">3 taken</option>
                                    <option value="4">4 taken</option>
                                    <option value="5">5 taken</option>
                                    <option value="6">6 taken</option>
                                    <option value="7">7 taken</option>
                                    <option value="8">8 taken</option>
                                    <option value="9">9 taken</option>
                                    <option value="10">10 taken</option>
                                    <option value="11">11 taken</option>
                                    <option value="12">12 taken</option>
                                    <option value="13">13 taken</option>
                                    <option value="14">14 taken</option>
                                    <option value="15">15 taken</option>
                                </select>
                            </DropDown>

                            <p style={{ color: 'white' }}>Beschrijf taken:</p>

                            {stepCreators}

                            <div styleName="buttons">
                                <p
                                    onClick={() =>
                                        this.setState({ showSplit: false })
                                    }
                                >
                                    Annuleer
                                </p>
                                <p styleName="save" onClick={this.splitTask}>
                                    Opslaan
                                </p>
                            </div>
                        </Fragment>
                    )}
                </div>
            </div>
        );
    }
}

class StepCreator extends Component {
    constructor() {
        super();

        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleTimeChange = this.handleTimeChange.bind(this);
    }

    handleTextChange(event) {
        this.props.handleTextChange(event.target.value, this.props.index);
    }

    handleTimeChange(event) {
        this.props.handleTimeChange(event.target.value, this.props.index);
    }

    render() {
        let options = [];

        if (this.props.user && this.props.user.use_timer) {
            for (let index = 0; index < timeOptionArray.length; index++) {
                options.push(
                    <option key={index} value={timeOptionArray[index]}>
                        {timeOptionArray[index]} min
                    </option>
                );
            }
        } else {
            options.push(
                <option key={1} value={10}>
                    -
                </option>
            );
        }

        return (
            <div styleName="step-creator">
                <input
                    value={this.props.step.name}
                    onChange={this.handleTextChange}
                    styleName="update-input"
                    type="text"
                    maxLength="30"
                    placeholder="Bijvoorbeeld par 1,2,3"
                />
                <DropDown type="dark" border>
                    <select
                        value={this.props.step.time}
                        onChange={this.handleTimeChange}
                    >
                        {options}
                    </select>
                </DropDown>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskView);
